import { Routes } from '@angular/router';
import {AuthGuard} from '@auth0/auth0-angular';;
import { LoadHandoverComponent } from './load-handover.component';
import { ManageLoadHandoversGuard } from '../core/guards/manage-load-handovers.guard';
import { LoadHandoverMapComponent } from './load-handover-map/load-handover-map.component';

export const LOAD_HANDOVERS_ROUTES: Routes = [
  {
    path: 'load-handovers',
    data: { loadHandoversView: true },
    component: LoadHandoverComponent,
    canActivate: [AuthGuard, ManageLoadHandoversGuard],
    children: [
      { path: 'map', component: LoadHandoverMapComponent },
      { path: '**', redirectTo: '' }
    ]
  }
];
